import React from 'react';
import styled from 'styled-components';
import { IconWrapper, SvgIcon } from '../Icon';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../ActionsVisibilityContext';
import * as EditableTextAreaUI from './EditableTextAreaUI';
import EditableTextAreaValue from './EditableTextAreaValue';
import TableEditableCellPlaceholder from '../Table/TableEditableCellPlaceholder';

interface IProps {
  value: string;
  onClick: () => void;
  placeholder: string;
  isBold?: boolean;
  isRenamed?: boolean;
}

const EditIconWrapper = styled(IconWrapper)`
  margin-left: auto;
`;

const EditableTextAreaBasic = ({
  value,
  placeholder,
  onClick,
  isBold,
  isRenamed,
}: IProps) => {
  const { actionsVisible, showActions, hideActions, blurActions } =
    useActionsVisibilityContext();

  const handleClick = () => {
    hideActions();
    onClick();
  };

  if (!value.length) {
    return (
      <TableEditableCellPlaceholder
        placeholder={placeholder}
        iconName="pencil"
        onMouseEnter={showActions}
        onMouseLeave={hideActions}
        onBlur={blurActions}
        onClick={handleClick}
        hidden={!actionsVisible}
      />
    );
  }

  return (
    <EditableTextAreaUI.ValueContainer
      onMouseEnter={showActions}
      onMouseLeave={hideActions}
      onBlur={blurActions}
      onClick={handleClick}
    >
      <EditableTextAreaValue
        isBold={isBold}
        isRenamed={isRenamed}
        value={value}
      />
      <EditIconWrapper size={16}>
        {actionsVisible && (
          <SvgIcon name="pencil" width={16} height={16} isHoverable />
        )}
      </EditIconWrapper>
    </EditableTextAreaUI.ValueContainer>
  );
};

export default withActionsVisibilityContext(EditableTextAreaBasic);
